export const SITE = {
  name: "The Office Meal Co.",
  tagline: "Deliciously Managed",
  phoneDisplay: "+91 91487 90287",
  phoneRaw: "919148790287",
  email: "sales@theofficemealco.com",
  address:
    "1st Cross, Vinayaka Layout, Bettadasanpura, Electronic City, Bengaluru 560100",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_corporate-meals-3/artifacts/1ioxze4u_IMG-20250721-WA0001.jpg",
  whatsappMessage:
    "Hello, I'd like to enquire about corporate catering with The Office Meal Co.",
  // Hero background video — local self-hosted file in /public.
  // Replace /hero-bg.mp4 (and /hero-bg.webm) with your own clips by overwriting the files in /app/frontend/public/.
  heroVideo: {
    primary: "/hero-bg.webm",
    fallback: "/hero-bg.mp4",
    poster: "/hero-poster.jpg",
  },
  social: {
    linkedin: "https://www.linkedin.com/company/the-office-meal-company/",
    instagram: "https://www.instagram.com/theofficemealco",
  },
};

export const whatsappHref = `https://wa.me/${SITE.phoneRaw}?text=${encodeURIComponent(
  SITE.whatsappMessage
)}`;
